import React from "react";
import WidgetsOne from "../Widgets/WidgetsOne";
// import WidgetsTwo from "../Widgets/WidgetsTwo";
import styles from "./widgetswrapper.module.scss";
import { Col, Row } from "reactstrap";
import image1 from "../../../assets/images/status-icons/product.png";
import image2 from "../../../assets/images/status-icons/vendor.png";
import image3 from "../../../assets/images/status-icons/verified.png";
import image4 from "../../../assets/images/status-icons/purchase.png";
import { useSelector } from "react-redux";

const WidgetsWrapper = () => {
  const { products, sellers, brands, tags } = useSelector(
    (state) => state.appReducer
  );

  const welcomeData = [
    {
      id: 1,
      title: "Total Products",
      value: products?.length ? products.length : 0,
      position: "+50%",
      deration: "up",
      image: image1,
    },
    {
      id: 2,
      title: "Total vendor",
      value: tags?.length ? tags.length : 0,
      position: "+70%",
      deration: "up",
      image: image2,
    },
    {
      id: 3,
      title: "Verified Productsi",
      value: brands?.length ? brands.length : 0,
      position: "-20%",
      deration: "down",
      image: image3,
    },
    {
      id: 4,
      title: "Purchase rate",
      value: sellers?.length ? sellers.length : 0,
      position: "+70%",
      deration: "up",
      image: image4,
    },
  ];
  return (
    <>
      <div className={styles["widgets_container"]}>
        <Row className={styles["widget_inner_container"]}>
          {welcomeData?.map((el) => (
            <Col md={6} key={el.id}>
              <WidgetsOne data={el} />
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

export default WidgetsWrapper;
